/* global debounce */
$( $ => {
  const wrapperDiv = $( '.bs-div--careers-rewards-cards-wrapper' );
  if ( wrapperDiv.length === 0 ) return;
  const cards = wrapperDiv.find( '.bs-card' );
  const titles = wrapperDiv.find( '.bs-card__title' );
  const descriptions = wrapperDiv.find( '.bs-card__description' );
  const duration = 200;

  const isMobile = () => {
    return window.matchMedia( '(max-width: 767.98px)' ).matches;
  };

  const expandCard = card => {
    const selectedDescription = card.find( '.bs-card__description' );
    descriptions.not( selectedDescription ).slideUp( duration );
    cards.not( card ).removeClass( 'expanded' );
    selectedDescription.slideDown( duration );
    card.addClass( 'expanded' );
  };

  const collapseCard = card => {
    const selectedDescription = card.find( '.bs-card__description' );
    selectedDescription.slideUp( duration );
    card.removeClass( 'expanded' );
  };

  const collapseAll = () => {
    descriptions.slideUp( duration );
    cards.removeClass( 'expanded' );
  };

  const init = () => {
    if ( isMobile() ) {
      expandCard( cards.eq( 0 ) );
    } else {
      collapseAll();
    }
  };

  titles.on( 'click', e => {
    const card = $( e.target ).closest( '.bs-card' );
    if ( card.hasClass( 'expanded' ) ) {
      collapseCard( card );
      return;
    }
    expandCard( card );
  } );

  init();
  $( window ).on( 'resize', debounce( init, 100 ) );
} );
